import type { Rule } from "antd/lib/form";
import i18n from "i18next";

import type { ValidationRuleParams } from "../../../types/types";

export const getRequiredRule = (validationRuleParams: ValidationRuleParams) => {
    if (!validationRuleParams) {
        return undefined;
    }

    return { required: true, message: i18n.t("common.input.required.error") } as Rule;
};
